import {getRequiredError, valid} from "./ValidationChecker";
import {unSelectCode} from "./simmsDrawerMethod";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";


export function dateOnChange(f, t, v, required) {
    valid(required, t, v, f);
    setState(f, t, v);
}

function setState(f, t, v) {
    f((prev) => ({
        ...prev,
        [t]: v,
    }));
}







export function dateOnSelected(f, u, id, t, v, required) {

    if (!!getRequiredError(required, v)) {
        alert("필수값 입니다.")
        return;
    }

    const singleUpdateDto = {
        id: id,
        value: v,
        fieldName: t,
    }
    getToastMessageByApi(u, singleUpdateDto,()=> setState(f, t, v));
}

export function dateOnSubChange(f, t, dto, v, required) {
    valid(required, t, v, f);
    setSubState(f, dto, v, t);
}


export function dateOnSubSelected(f, u, t, dto, v, required) {

    if (!!getRequiredError(required, v)) {
        alert("필수값 입니다.")
        return;
    }

    const singleUpdateDto = {
        id: dto.id,
        value: v,
        subId: dto.subId,
        fieldName: dto.fieldName,
    }
    getToastMessageByApi(u, singleUpdateDto, ()=> setSubState(f, dto, v, t));
}
function setSubState(f, dto, v, t) {
    f(prevState => {
        const newState = {...prevState};
        const obj = {
            [dto.subName]: {id: dto.subId},
            [dto.fieldName]:  v,
        };
        const targetArray = [...(newState[t] || [])];
        targetArray[dto.index] = obj;

        newState[t] = targetArray;
        return newState;
    });
}


function getToastMessageByApi(u, updateObj, f) {
    u(updateObj).then(r => {
            if (r.status === 200) {
                console.log(r)
                handleActiveToast({
                    description: "", message: "수정 되었습니다.", labelListener: () => {
                    }
                })
                f();
            } else if (r.status === 201 || (r.status === 202)) {
                handleActiveError({message: r.data.title, description: r.data.reason});
            } else {
                handleActiveError({message: '처리실패', description: '알수 없는 원인'});
            }
            return false;
        }
    );
}